export const collectorRoutePaths = {
  ROOT: '/',
  REGISTER: '/register',
  REGISTER_ACCOUNT: '/register/account',
  REGISTER_VERIFIED: '/register/verified',
  PASSWORD_CHANGED: '/auth/password-changed',
  HOME: '/home',
  LISTINGS: '/listings',
  LISTING_DETAIL: '/listings/:id',
  CREATE_OFFER: '/listings/:id/offers/create',
  INQUIRIES: '/inquiries',
  OFFERS: '/offers',
  OFFER_DETAIL: '/offers/:id',
  SALES_AGREEMENTS: '/sales-agreements',
  SALES_AGREEMENT_DETAIL: '/sales-agreements/:id',
  SELLERS: '/sellers',
  SELLER_DETAIL: '/sellers/:id',
  SELLER_PROFILE: '/sellers/:id/profile',
  EDIT_OFFER: '/offer/:id/edit',
  CHECKOUT: '/offers/:id/checkout',
  ACCOUNT: '/account',
  PROFILE: '/account/profile',
  EDIT_PROFILE: '/account/profile/edit',
  ABOUT: '/about',
  ABOUT_SECTION: '/about/:section',
  ABOUT_PRIVACY: '/about/privacy',
  ABOUT_TERMS: '/about/terms',
  ABOUT_HELP: '/about/help',
  UNPUBLISHED: '/unpublished',
};
